module.exports = __webpack_public_path__ + "img/edit-jddetail.5e4bc507.svg";